import React from 'react'
import { Html } from '@react-three/drei'
import useStore from '../StateStore/store'

const Video = ({}) => {
    const ytRef = React.useRef()

    const propogation = useStore(state => state.propogateToStall)
    const propogate = useStore((state) => state.propogateToStall.propogateTo)
    const propogateState = useStore((state) => state.propogateToStall.setPlayerState)
    const exitState = useStore((state) => state.propogateToStall.exitButton)
    const videoDisplay = useStore(store => store.videoDisplay)
    const videoPosition = useStore(store => store.videoDisplay.position)
    const videoTrigger = useStore(store => store.videoDisplay.videoTrigger)

    return (
        <>
            {
                 videoPosition  && propogation.exitButton === true ? (
                    <Html
                        ref= {ytRef}
                        scale ={[100, 111, 100]}
                        distanceFactor={0.1}
                        position={[videoDisplay.position.x, videoDisplay.position.y, videoDisplay.position.z]}
                        rotation={[0, videoDisplay.rotation, 0]}
                        transform
                    >
                            <iframe className= "video-display visible" loop autoPlay src = "https://www.youtube.com/embed/ujC7rsfQTf4?autoplay=1"></iframe> 
                    </Html>
                ) : null 
            }
        </>
        
    )
}

export default Video
